import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import CouponEvent from './CouponEvent';
import PotentialWinBox from './PotentialWinBox';
import {playableInMultiple } from '../../data/purchase-service';
import { getConfiguration } from '../../data/utils/configuration';
import { ShopContext } from '../../data/shop/ShopConf';

function MultipleBets(props) {
    const betslipContext = useContext(BetslipContext);
	
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const container = "multibets";
    const reactKeyPWB = 'key-potential-win-box-coupon-' + couponKey + '-container-' + container;
    
    let selections = coupon.selections;
    
    // restoring the selections array for the draw
    let restoredSelections = [];
    for (let k in selections) {
    	let selection = selections[k];
    	const playableInMulti = playableInMultiple(selection.bets);
    	if (selection.bets.length === 1) {
    		// duplicate object
    		selection = JSON.parse(JSON.stringify(selection));
    		restoredSelections.push(selection);
    	} 
    	else {
    		for (let km = 0; km < selection.bets.length; km++) {
    			let bet = selection.bets[km];
    			// km == 0; it is the first bet choosed: I've to render it in anycase
    			// playableInMulti = true, it means that this draw can be rendered in multibets everytime, also if it is sharing
    			// the pal.avv with another draw selected before.
    			if(km == 0 || playableInMulti){
    				let duplicatedSelection  = JSON.parse(JSON.stringify(selection));
    				duplicatedSelection.bets = [];
        			duplicatedSelection.bets.push(bet);
        			restoredSelections.push(duplicatedSelection);			
    			}
    		}
    	}
    }
    const conf = getConfiguration();
    const shopContext = React.useContext(ShopContext);
    const fastbetAliasEnabled = shopContext.enabled && conf.fbt === 'XR';
    
    let classContainer = "widget-schedina-giocate" + (betslipContext.isKeypadShown()? ' keypad-shown' : '');
    if(fastbetAliasEnabled){
    	classContainer += ' adj-margin-top'; 
    }
    
    return (
        <div className="tab-pane active" id="widget-schedina-1_multipla" role="tabpanel">
            <div className={classContainer}>
                {restoredSelections.map(function(selection) {
                    // always the first bet is taken: if an event had more than 1 bet, then I will face a duplicated event in the next selection
                    let betKey = selection.bets[0].scomSogei + "_" + selection.bets[0].handicap + "-draw-" + selection.bets[0].draw;
                    let reactKey = "key-bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + selection.pal + "-avv-" + selection.avv + "-for-bet-" + betKey;
                    return (
                        <React.Fragment key={reactKey}>
                            <CouponEvent selection={selection} couponKey={couponKey} container={container} />
                        </React.Fragment>
                    )
                })}
                <div className="hidden-element"></div>
            </div>
            <div className="carrello-fixed">
                <PotentialWinBox container={container} couponKey={couponKey} key={reactKeyPWB} />
            </div>
        </div>
    );
}

export default MultipleBets;